import { Component, OnInit } from '@angular/core';
import { StudyEditorContext } from '../../study-editor.context';
import { DatasetTypeEnum } from '../../../shared/dataset/model/dataset-type.enum';
import { DatasetModel } from '../../../shared/dataset/model/dataset.model';
import { Principal } from '../../../shared';
import {
    DELETE_SSA_RESULTS_PERMISSIONS, EXPORT_SSA_RESULTS_PERMISSIONS,
    SSA_MEANS_BLUE_PERMISSIONS,
    SSA_SUMMARY_STATISTICS_PERMISSIONS
} from '../../../shared/auth/permissions';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalConfirmComponent } from '../../../shared/modal/modal-confirm.component';
import { DatasetService } from '../../../shared/dataset/service/dataset.service';
import { StudyEditorService } from '../../study-editor.service';
import { AlertService } from '../../../shared/alert/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { SingleSiteAnalysisService } from '../../../single-site-analysis/single-site-analysis.service';
import { finalize } from 'rxjs/internal/operators/finalize';
import { FileDownloadHelper } from '../../../entities/sample/file-download.helper';

@Component({
    selector: 'jhi-summary-statistics',
    templateUrl: './summary-statistics.component.html',
    styleUrl: './summary-statistics.component.scss'
})
export class SummaryStatisticsComponent implements OnInit {

    protected readonly DELETE_SSA_RESULTS_PERMISSIONS = DELETE_SSA_RESULTS_PERMISSIONS;
    protected readonly EXPORT_SSA_RESULTS_PERMISSIONS = EXPORT_SSA_RESULTS_PERMISSIONS;

    summaryStatisticsDataset: DatasetModel;
    meansDataset: DatasetModel;
    currentDataset: DatasetModel;
    isLoading: boolean;

    constructor(private studyEditorContext: StudyEditorContext,
                public principal: Principal,
                private modalService: NgbModal,
                private datasetService: DatasetService,
                private studyEditorService: StudyEditorService,
                private alertService: AlertService,
                private translateService: TranslateService,
                private singleSiteAnalysisService: SingleSiteAnalysisService,
                private fileDownloadHelper: FileDownloadHelper) { }

    ngOnInit(): void {
        this.summaryStatisticsDataset = this.studyEditorContext.allDatasets.find(dataset => dataset.datasetTypeId === DatasetTypeEnum.SUMMARY_STATISTICS_DATA.valueOf());
        this.meansDataset = this.studyEditorContext.allDatasets.find(dataset => dataset.datasetTypeId === DatasetTypeEnum.MEANS.valueOf());
        if (this.meansDataset) {
            this.currentDataset = this.meansDataset;
        }
        if (this.summaryStatisticsDataset) {
            this.currentDataset = this.summaryStatisticsDataset;
        }
    }

    viewDataset(dataset: DatasetModel) {
        this.currentDataset = dataset;
    }

    exportSSAResults() {
        this.singleSiteAnalysisService.exportSSAResults(this.studyEditorContext.studyId).pipe(finalize(() => {
            this.isLoading = false;
        })).toPromise().then((response: any) => {
            const fileName = this.fileDownloadHelper.getFileNameFromResponseContentDisposition(response);
            this.fileDownloadHelper.save(response.body, fileName);
        });
    };

    deleteSSAResults() {
        this.showConfirmDeleteSSAModal();
    };

    showConfirmDeleteSSAModal() {

        const modalRef = this.modalService.open(ModalConfirmComponent as Component, { size: 'md', backdrop: 'static' });
        modalRef.componentInstance.message = this.translateService.instant('study-editor.summary-results.delete-confirm-message');

        modalRef.result.then(async () => {
            try {
                if (this.summaryStatisticsDataset && this.summaryStatisticsDataset.datasetId) {
                    await this.datasetService.deleteDataset(this.studyEditorContext.studyId, this.summaryStatisticsDataset.datasetId).toPromise();
                }
                if (this.meansDataset && this.meansDataset.datasetId) {
                    await this.datasetService.deleteDataset(this.studyEditorContext.studyId, this.meansDataset.datasetId).toPromise();
                }
                this.studyEditorService.triggerRefreshAndWait().then(() => {
                    this.alertService.success('study-editor.summary-results.delete-successful');
                    this.studyEditorService.navigateToDatasetTab(this.studyEditorContext.studyId, this.studyEditorContext.getPlotDataset().datasetId);
                });
            } catch (response) {
            }
        });
    };

    protected readonly SSA_SUMMARY_STATISTICS_PERMISSIONS = SSA_SUMMARY_STATISTICS_PERMISSIONS;
    protected readonly SSA_MEANS_BLUE_PERMISSIONS = SSA_MEANS_BLUE_PERMISSIONS;

}
